import React from 'react';
import './OfferPage.css';

import { Heading, Offer, PageTitle } from '../../../components';
import { offers } from '../../../constants';



const OfferPage = () => {
  return (

    <>

      {/* Page title */}
      <PageTitle title={'Tour Offers'} page={'Tour Offers'} />

      <section className="offers">

        {/* Section Heading */}
        <Heading title={'Latest Offers'} subTitle={'Our Deals'} />

        <div className="box-container">
            {offers.map((offer) => (
              <Offer key={offer.id} offer={offer} />
            ))}
        </div>

      </section>
    </>

  );
};

export default OfferPage;